import styled from 'styled-components';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import variables from '../../../../styles/variables';
import Image from '../../../UI/Image/Image';

export const CarrierOfferForPhone = styled(AccordionItem)`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 60px;
  padding: 10px 20px;
  margin: 0 0 15px 0;
  border-radius: 8px;
  border: 1px solid ${variables.colorGreyMedium};
  font-size: 14px;
  background: none;
`;

export const CollapsedContainer = styled.div`
  display: grid;
  position: relative;
  width: 100%;
  grid-template-columns: 1.2fr 1fr 1fr 1fr 0.5fr;
  grid-template-areas: 'logo price plan promo button';
  grid-gap: 6px;
  align-items: center;
  justify-items: center;
  margin: 0;
  font-size: 12px;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      '. logo button'
      'price promo plan';
  }
  @media screen and (max-width: 500px) {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      '. logo button'
      'price promo plan';
  }
`;

export const AccordionWrapper = styled(AccordionItemHeading)`
  width: 100%;
`;
export const AccordionButton = styled(AccordionItemButton)`
  width: 100%;
  cursor: pointer;
  /* When content is expanded */
  &[aria-expanded='true'] .arrowButton {
    border-color: ${variables.colorRed};
    transform: rotate(-135deg);
  }
`;

export const TelecomProvider = styled.div`
  height: 40px;
  width: auto;
  padding: 8px;
  grid-area: logo;
  text-align: center;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    height: 26px;
    padding: 3px;
  }
  @media screen and (max-width: 500px) {
    height: 26px;
    padding: 3px;
  }
`;

export const TelecomLogo = styled(Image)`
  height: 100%;
  width: auto;
`;

export const UpFrontPrice = styled.div`
  text-align: center;
  grid-area: price;
`;

export const MonthlyPrice = styled.div`
  text-align: center;
  grid-area: plan;
`;

export const Price = styled.span`
  font-weight: 600;
  font-size: 18px;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    font-size: 14px;
  }
  @media screen and (max-width: 500px) {
    font-size: 14px;
  }

  @media screen and (max-width: 380px) {
    font-size: 12px;
  }
`;

export const DetailLabel = styled.p`
  font-size: 10px;
  font-weight: 300;
  margin: 3px 0 0 0;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    font-size: 12px;
    margin: 0;
  }
  @media screen and (max-width: 500px) {
    font-size: 12px;
    margin: 0;
  }
`;

export const PromoWrapper = styled.div`
  grid-area: promo;
  text-align: center;
  .PhoneListTarget p span {
    @media screen and (min-width: 768px) and (max-width: 1023px) {
      font-size: 14px;
    }
    @media screen and (max-width: 500px) {
      font-size: 14px;
    }

    @media screen and (max-width: 380px) {
      font-size: 12px;
      margin-bottom: 0.15rem;
    }
  }
`;

export const NoPromo = styled.p`
  grid-area: promo;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
  color: ${variables.colorGreyDark};
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    font-size: 12px;
  }
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;

export const ButtonGraphicWrapper = styled.div`
  grid-area: button;
  justify-self: end;
`;

export const ButtonGraphic = styled.div`
  width: 10px;
  height: 10px;
  border-right: solid 2px #4a4a4a;
  border-bottom: solid 2px #4a4a4a;
  transform: rotate(45deg);
  margin-top: -5px;
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    width: 8px;
    height: 8px;
  }
  @media screen and (max-width: 500px) {
    width: 8px;
    height: 8px;
  }
`;

export const ExpandedTierDetails = styled(AccordionItemPanel)`
  width: 100%;
  margin-top: 15px;
  padding: 16px 6px 0 6px;
  border-top: solid 1px ${variables.colorGreyMedium};
`;

export const Disclaimer = styled.span`
  p {
    font-size: 12px;
    line-height: 1.6;
    width: 100%;
    color: ${variables.colorBlack};
    margin-bottom: 5px;
    /* Tier plan name */
    strong {
      font-weight: 400;
      background: #333333;
      color: ${variables.colorWhite};
      border-radius: 5px;
      padding: 4px 6px;
      margin: 3px;
      white-space: nowrap;
    }
  }
`;
